import React from 'react'

function ContactContent() {
  const font = '"Terminal ", monospace'
  return (
    <div id='contact-content' style={{
      display:'flex',
      flexFlow: 'column',
      //  margin: 'auto',
      //marginTop: '50%',
      overflowX: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: font,
      //position: 'absolute',
      //marginBottom: '50%',
      //verticalAlign: 'middle',
      width: '100%',
        height: '100%',
    }}>
      <div id='links' style={{
        display: 'flex',
        flexFlow: 'row',
        margin: 'auto',
        gap: '5em',
        maxWidth: '100%',
        //height: '100%',
      }}>
        <a href='https://www.linkedin.com/in/dan-villa-b302a8232/' rel="noreferrer" target={"_blank"} style={{
          textAlign: 'center',
        }}>
        <img src={require('../img/linkedin.svg.png')} style={{
                margin: 'auto',
                width: '5em',
                height: '5em',
                //verticalAlign: 'center',
            }}></img>
            <br></br>
          linkedin
        </a>
        
        <a href='https://github.com/dan-v4' rel="noreferrer" target={"_blank"}style={{
          textAlign: 'center',
        }}>
          <img src={require('../img/github_logo.png')} style={{
                margin: 'auto',
                width: '5em',
                height: '5em',
                //verticalAlign: 'center',
            }}></img>
            <br></br>
          github
        </a>
      </div>
    </div>
  )
}

export default ContactContent